/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  audiencePreview(data) {
    return axios.post(`${this.url}/audience_preview`, data);
  }

  details(id) {
    return axios.get(`${this.url}/${id}/details`);
  }

  recipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  reschedule(id, data = {}) {
    return axios.patch(`${this.url}/${id}/reschedule`, data);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new CampaignsAPI();
